import React from "react";
import CustomeButton from "../Button";
import fileUploadLogo from "../../assets/attachment-paperclip.svg";
import FileUploadModal from "../Processes/conversations/FileUploadModal";
import ShareholderRegistered from "./ShareholderRegistered";
import useShareholderAttachments from "./useShareholderAttachments";
import DocumentTable from "~/components/document-table/DocumentTable";
import { formatDate } from "~/utils/CSVFunctions";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";

const mapFilesToDocumentRows = (files) =>
  (files || []).map((item) => {
    const f = item.file;
    const subCategoryCode =
      typeof f?.subcategory === "object"
        ? f?.subcategory?.code
        : f?.subcategory;
    return {
      name: f?.fileName || f?.name,
      description: f?.description ?? "",
      category: f?.category,
      subCategory: subCategoryCode,
      subcategoryName: f?.subcategoryName,
      fileYearMonth: f?.fileYearMonth,
      year: f?.year ?? f?.fileYearMonth?.year ?? f?.customYear,
      month: f?.month ?? f?.fileYearMonth?.month,
      blob_url: f?.objectURL,
      createdAt: f?.lastModified || new Date().toISOString(),
      file_type: f?.type,
      _original: item,
    };
  });

const ShareholderAttachments = ({
  isCongrats,
  setIsCongrats,
  files,
  setFiles,
  entityData,
  setActiveIndex,
  regData,
  resetRegData,
  shareholderType,
}) => {
  const {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getShareholder,
    downloadFileHandler,
    handleDelete,
    role,
  } = useShareholderAttachments(files, setFiles, regData, shareholderType);
  const service = entityData?.active_services?.map((data) => data?.name) || [];
  return (
    <>
      {!isCongrats ? (
        <div className="formgrid grid">
          <div className="w-full flex justify-content-between mb-4">
            <div>
              <p className="add-new-entity-heading mb-2">Attachments</p>
              <p className="input-label m-0">
                Upload and categorize supporting documents for this shareholder.
              </p>
            </div>
            <div className="btns-container flex align-items-center">
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          </div>
          {files.length === 0 && (
            <div className="no-documents-uploaded-section w-full">
              <img
                src={fileUploadLogo}
                alt="file-upload"
                className="file-upload-logo"
              />
              <p className="add-new-entity-heading mb-0">
                No Documents uploaded yet
              </p>
              <p className="drag-drop-text m-0">
                Upload supporting documents for this shareholder, such as ID or
                proof of address.
              </p>
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          )}
          {files.length > 0 && (
            <DocumentTable
              value={mapFilesToDocumentRows(files)}
              formatDate={formatDate}
              onDelete={(row) => handleDelete(row._original)}
              onDownload={(row) => downloadFileHandler(row._original?.file)}
              hideDetailsSidebar
              emptyMessage="No attachments found"
            />
          )}
        </div>
      ) : (
        <ShareholderRegistered
          setActiveIndex={setActiveIndex}
          resetRegData={resetRegData}
          setIsCongrats={setIsCongrats}
        />
      )}
      <FileUploadModal
        entitydata={entityData}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={getShareholder}
        placeholder={"Choose a file to upload"}
        relatedType={"SHAREHOLDER_ONBOARDING"}
        uploadedFile={files}
        categories={mergeCategories(["Entities +"], role)}
      />
    </>
  );
};

export default ShareholderAttachments;
